import { Controller } from "@hotwired/stimulus"
import { usesSidebarLayout } from "../utils/layout_media"

// Desktop dating profile sidebar plumbing. Two jobs:
// - Photo stepper: delegates clicks on the [data-photo-step] tap zones inside
//   the panel (the swipe deck has its own stepper; this one covers sidebars).
// - Open/close: when a sidebar target exists (match chat page), the close
//   button hides it, the header peer affordance toggles it, Escape closes it.
// On the preferences page it is attached to the always-visible preview aside,
// so only the photo stepper part is active there.
export default class extends Controller {
    static targets = ["sidebar"]

    connect() {
        this._onClick = (e) => {
            let zone = e.target.closest("[data-photo-step]")
            if (!zone || !this.element.contains(zone)) return
            e.preventDefault()
            e.stopPropagation()
            this._stepPhoto(zone)
        }
        this._onKeydown = (e) => {
            if (e.key !== "Escape") return
            if (!this.hasSidebarTarget || this.sidebarTarget.classList.contains("d-none")) return
            this.close()
        }
        this.element.addEventListener("click", this._onClick)
        document.addEventListener("keydown", this._onKeydown)
        this._mountActionsMenu()
    }

    disconnect() {
        this.element.removeEventListener("click", this._onClick)
        document.removeEventListener("keydown", this._onKeydown)
    }

    close() {
        if (this.hasSidebarTarget) this.sidebarTarget.classList.add("d-none")
    }

    toggle() {
        if (!this.hasSidebarTarget) return
        if (!usesSidebarLayout()) return
        this.sidebarTarget.classList.toggle("d-none")
    }

    _sidebarRoot() {
        if (this.hasSidebarTarget) return this.sidebarTarget
        if (this.element.matches(".detail-sidebar")) return this.element
        return null
    }

    _mountActionsMenu(content) {
        let sidebar = this._sidebarRoot()
        if (!sidebar) return
        let holder = content || sidebar.querySelector(".detail-sidebar-content")
        let menu = holder?.querySelector(".msg-detail-menu")
        if (!menu) return
        let actions = sidebar.querySelector(".detail-sidebar-actions")
        let closeBtn = actions?.querySelector(".detail-sidebar-close")
        if (!actions) return
        this._unmountActionsMenu(sidebar)
        if (closeBtn) actions.insertBefore(menu, closeBtn)
        else actions.appendChild(menu)
    }

    _unmountActionsMenu(sidebar = this._sidebarRoot()) {
        sidebar?.querySelectorAll(".detail-sidebar-actions .msg-detail-menu").forEach((el) => el.remove())
    }

    _stepPhoto(zone) {
        let photo = zone.closest(".dating-card-photo")
        if (!photo) return
        let imgs = Array.from(photo.querySelectorAll(".dating-card-photo-img"))
        if (imgs.length < 2) return
        let current = imgs.findIndex((img) => !img.classList.contains("d-none"))
        let next = Math.min(Math.max(current + parseInt(zone.dataset.photoStep, 10), 0), imgs.length - 1)
        if (next === current) return
        imgs.forEach((img, i) => img.classList.toggle("d-none", i !== next))
        photo.querySelectorAll(".dating-photo-dot").forEach((dot, i) => dot.classList.toggle("is-active", i === next))
    }
}
